import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { CheckCircle2, Package, Truck } from "lucide-react";
import { api, inr } from "../lib/api";
import { WHATSAPP_LINK } from "../lib/constants";

const OrderSuccess = () => {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${orderId}`).then((r) => setOrder(r.data)).catch(() => {});
  }, [orderId]);

  return (
    <div className="max-w-2xl mx-auto px-4 py-16 text-center">
      <div className="h-20 w-20 rounded-full bg-[#1F4D2E] flex items-center justify-center mx-auto animate-fade-up">
        <CheckCircle2 size={44} className="text-white" />
      </div>
      <h1 className="font-serif font-bold text-3xl sm:text-4xl text-[#1C2B20] mt-6" data-testid="order-success-title">
        Order Confirmed!
      </h1>
      <p className="text-[#5A6B5D] mt-3">
        Thank you{order ? `, ${order.customer_name}` : ""}! Your order has been placed successfully.
      </p>

      {order && (
        <div className="mt-8 bg-white rounded-2xl border border-[#E2DAD0] p-6 text-left">
          <div className="flex justify-between items-center pb-4 border-b border-[#E2DAD0]">
            <span className="text-sm text-[#8A9A8D]">Order ID</span>
            <span className="font-mono text-sm font-semibold text-[#1C2B20]" data-testid="order-id">
              #{order.id.slice(0, 8).toUpperCase()}
            </span>
          </div>
          <div className="py-4 space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-[#5A6B5D]">Order Total</span>
              <span className="font-semibold text-[#1C2B20]">{inr(order.subtotal)}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-[#5A6B5D]">Advance Paid</span>
              <span className="font-semibold text-[#1F4D2E]">{inr(order.advance_amount)}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-[#5A6B5D]">Balance on Delivery</span>
              <span className="font-semibold text-[#1C2B20]">{inr(order.balance_due)}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-[#5A6B5D]">Status</span>
              <span className="font-semibold text-[#1F4D2E] capitalize">{order.status}</span>
            </div>
          </div>
          <div className="flex items-center gap-6 pt-4 border-t border-[#E2DAD0] text-xs text-[#5A6B5D]">
            <span className="flex items-center gap-1.5"><Package size={15} className="text-[#1F4D2E]" /> Packed with care</span>
            <span className="flex items-center gap-1.5"><Truck size={15} className="text-[#1F4D2E]" /> Delivered in 3-5 days</span>
          </div>
        </div>
      )}

      <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
        <Link
          to="/shop"
          className="bg-[#1F4D2E] hover:bg-[#163A22] text-white font-medium rounded-full px-8 py-3 transition-colors"
          data-testid="order-continue-shopping"
        >
          Continue Shopping
        </Link>
        <a
          href={WHATSAPP_LINK}
          target="_blank"
          rel="noopener noreferrer"
          className="border-2 border-[#1F4D2E] text-[#1F4D2E] hover:bg-[#1F4D2E] hover:text-white font-medium rounded-full px-8 py-3 transition-colors"
        >
          Track via WhatsApp
        </a>
      </div>
    </div>
  );
};

export default OrderSuccess;
